/*
 * Trafford Past Collections — tabbed Swiper slider.
 * Each tab panel has its own Swiper (with scoped arrows + pagination). Clicking a tab
 * shows its panel and updates that Swiper (panels start hidden, so layout is recomputed
 * on first show). No-op without Swiper.
 */
(function () {
  function initPanel(panel) {
    if (!window.Swiper || panel.dataset.swInit === '1') return;
    var el = panel.querySelector('.trafford-past__swiper');
    if (!el) return;
    /* eslint-disable no-new */
    new window.Swiper(el, {
      // 'auto' + fixed slide widths (CSS) so cards keep their size while the track
      // bleeds off the right edge of the viewport (left stays masked at the container).
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: panel.querySelector('.trafford-past__arrow--prev'),
        nextEl: panel.querySelector('.trafford-past__arrow--next')
      },
      pagination: {
        el: panel.querySelector('.trafford-past__pagination'),
        type: 'progressbar'
      },
      breakpoints: {
        750: { spaceBetween: 24 },
        990: { spaceBetween: 32 }
      }
    });
    panel.dataset.swInit = '1';
  }

  function initSection(section) {
    var panels = section.querySelectorAll('.trafford-past__panel');
    panels.forEach(initPanel);

    var tabs = section.querySelectorAll('.trafford-past__tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-panel') === idx;
          p.classList.toggle('is-active', on);
          if (on) {
            var el = p.querySelector('.trafford-past__swiper');
            if (el && el.swiper) el.swiper.update();
          }
        });
      });
    });
  }

  function initAll(root) {
    if (!window.Swiper) return;
    (root || document).querySelectorAll('.trafford-past').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
